
import { Component, Prop, Vue } from "vue-property-decorator";
import { commonModule, offersModule } from "@/store/modules/store-accessor";

@Component
export default class DeleteOfferPhotoModal extends Vue {
  @Prop() payload!: { photo: OfferPhotoDto; offer: OfferDto };

  isDeleting = false;

  get photoUrl() {
    return `${this.payload.photo.base_url.replace(
      /\/$/,
      ""
    )}/${this.payload.photo.src.replace(/^\//, "")}`;
  }

  hideModal() {
    commonModule.hideModal();
  }

  async deletePhoto() {
    this.isDeleting = true;
    try {
      await offersModule.deleteOfferPhoto({
        installationId: String(this.payload.offer.installation_id),
        offerId: String(this.payload.offer.id),
        photoId: String(this.payload.photo.id),
      });
      this.hideModal();
    } finally {
      this.isDeleting = false;
    }
  }
}
